(function (Drupal, $, once) {
  Drupal.behaviors.videoCardModals = {
    attach: function (context) {
      once('slider-card', '.slider-card', context).forEach(container => {
        const data = container.querySelector('.video-wrapper')?.getAttribute('data-video-content');
        if (!data) return;

        const img = container.querySelector('img');
        if (!img) return;

        img.addEventListener('click', () => {
          this.openModal(data);
        });
      });
    },

    openModal: function (data) {
      const $modal = $('<div id="video-card-dialog"><div class="video-dialog-wrapper">' + data + '</div></div>');

      const dialog = Drupal.dialog($modal[0], {
        title: 'Video',
        dialogClass: 'video-card-dialog-class',
        draggable: true, // ← enables dragging via the title bar
        modal: false,
        resizable: false,
        width: 620,
        minWidth: 600,
        position: {
          my: "center top",
          at: "center top+100",
          of: window
        },
        create: function () {
          // Force our own styling to override inline defaults
          $(this).closest('.ui-dialog').css({
            width: '620px',
            minWidth: '600px',
            minHeight: '315px',
            height: 'auto',
            top: '100px',
            left: 'calc(50% - 320px)',
            position: 'fixed'
          });
        },
        close: function () {
          $modal.remove();
        }
      });

      dialog.show();
    }
  };
})(Drupal, jQuery, once);
